import { createState } from "@hookstate/core";
import { AppState } from "./types";

export const state = createState<AppState>({
  confirmPortfolioProjectDeletion: {
    open: false,
    index: -1,
  },
});
